<form name="changeLogForm" [formGroup]="changeLogForm" (ngSubmit) = "onSubmitChangeLogForm()">
      <div style="display:flex">
        <div class="form-group changeLogForm">
          <p-listbox [options]="changedBy" 
                  [(ngModel)]="selectedUsers" 
                  multiple="multiple"  
                  [checkbox]="changedBySelectorFilter" 
                  formControlName="changedBy" 
                  [filter]="changedBySelectorFilter" 
                  optionLabel="name"
                  [disabled]="changedBySelectorDisabled" 
                 styleClass="changeLogList">
            <p-header class="p-list-header">
              Changed By
            </p-header>
          </p-listbox>
        </div>
        <div class="form-group loanDropDownStyle" >
          <p-listbox [options]="loans" 
              [(ngModel)]="selecletedLoans" 
              multiple="multiple" 
              [checkbox]="loansSelectorFilter" 
              formControlName="loanNumber" 
              [filter]="loansSelectorFilter"
              optionLabel="name"
              [disabled]="loansSelectorDisabled"
              styleClass="changeLogList"
             >
            <p-header class="p-list-header">
              Loan Number
            </p-header>
          </p-listbox>
        </div>
        <div>
          <div class="date-range-section">
            <div class="date-range-title">Date Range</div>
            <div class="calenderTop">
              <div class="calenderStyle">
                <p-calendar [(ngModel)]="minDate" formControlName="fromDate" [showIcon]="true" class="form-group" 
                  styleClass="treetableDate" >
                </p-calendar> <div class="calenderSpace">to</div>
                <p-calendar [(ngModel)]="maxDate" formControlName="toDate" [showIcon]="true" class="form-group" 
                  styleClass="treetableDate"></p-calendar>
              </div>
              <div class="days-margin-left">
                <a class="underline" (click)="setDateRange(6)">last 7 days</a>&nbsp;
                <a class="underline" (click)="setDateRange(29)">Last 30 days</a>&nbsp;
                <a class="underline" (click)="setDateRange(89)">Last 90 days</a>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-group buttonStyles">
          <button pButton  type="submit" label="{{viewButtonLabel}}" [disabled]="!changeLogForm.valid || disableChangeLogForm" class="margin-left-view-button"></button>
          <button pButton  type="button" label="Reset" (click)="resetForm()" class="ui-button-secondary margin-left"></button>
        </div>
      </div>      
</form>

<div *ngIf="showTable">
  <div class="excelStyle" *ngIf="changeLogData && changeLogData.length >0 && !loadingSearchResult">
      <span class="fa fa-file-excel-o"  style="font-size: 1.5em"></span>&nbsp;
      <a href="{{excelUrl}}" class="excelLink">Download To Excel</a>&nbsp;&nbsp;  {{records}} records found
  </div>

  <div *ngIf="formSubmitted" style="margin-top: 16px">  
    <p-table #dt [value]="changeLogData"
      [columns]="cols"
      autoLayout=true 
      [paginator]="isPaginatorVisible()" 
      [rows]="rowcount"
      [totalRecords]="records" 
      [rowsPerPageOptions]="[10,25,50,100]"
      dataKey="auctionUpdateHistoryID"
      rowExpandMode="multiple"
      (onLazyLoad)="onPage($event)"
      [lazy]="true"
      [lazyLoadOnInit] = "false"
      [resetPageOnSort] = "false"
      [loading]="loadingSearchResult">

      <ng-template pTemplate="header">
          <tr>
              <th style="width: 3em"></th>
              <ng-container *ngFor="let col of cols">
                <th *ngIf="col.showInHeader">
                  {{col.header}}
                </th>
              </ng-container>
          </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
          <tr *ngIf="!loading && changeLogData && changeLogData.length === 0">
              <td [attr.colspan]="10" class="center-align">No records found</td> 
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
          <tr>
            <td>
              <a href="#" [pRowToggler]="rowData">
                <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
              </a>
            </td>
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.showInHeader && col.field !='edit' && col.field !='UpdateStatusValue'">
                {{rowData[col.field]}}
              </td>
              <td *ngIf="col.showInHeader && col.field !='edit' && col.field == 'UpdateStatusValue'">
                  <span *ngIf="rowData[col.field] == 'Request Incomplete' || rowData[col.field] == 'Request Processing'" class="messageColorRed">
                    {{rowData[col.field]}}
                  </span> 
                  <span *ngIf="rowData[col.field] == 'Request Complete'" class="messageColorGreen">
                      {{rowData[col.field]}}
                  </span> 
              </td>
            </ng-container>
          </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-rowData  let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td width="50%" colspan="2">                        
              <div class="section-header">Changed Values</div>
              <div class="section-data"><span class="section-data-label">Reserve price ($): </span><span class="section-data-value center-align" *ngIf="rowData.UpdateStatusValue == 'Request Complete'"> {{rowData.reservePriceNew}}</span></div>
              <div class="section-data"><span class="section-data-label">% of initial Reserve Price: </span><span class="section-data-value center-align" *ngIf="rowData.UpdateStatusValue == 'Request Complete'"> {{rowData.initialReservePricePercentageNew}}</span></div>
              <div class="section-data"><span class="section-data-label">Reserve Reduction %: </span><span class="section-data-value center-align" *ngIf="rowData.UpdateStatusValue == 'Request Complete'"> {{rowData.reservePriceReductionPercentageNew}}</span></div>
            </td>
            <td width="50%" colspan="3">
                <div class="section-header">Previous Values</div>
                <div class="section-data"><span class="section-data-label">Reserve price ($): </span><span [ngClass]="rowData.reservePriceOld != rowData.reservePriceNew ? 'section-data-value-highlighted center-align' : 'section-data-value center-align'"> {{rowData.reservePriceOld}}</span></div>
                <div class="section-data"><span class="section-data-label">% of initial Reserve Price: </span><span [ngClass]="rowData.initialReservePricePercentageOld != rowData.initialReservePricePercentageNew ? 'section-data-value-highlighted center-align' : 'section-data-value center-align'"> {{rowData.initialReservePricePercentageOld}}</span></div>
                <div class="section-data"><span class="section-data-label">Reserve Reduction %: </span><span [ngClass]="rowData.reservePriceReductionPercentageOld != rowData.reservePriceReductionPercentageNew ? 'section-data-value-highlighted center-align' : 'section-data-value center-align'"> {{rowData.reservePriceReductionPercentageOld}}</span></div>
            </td>
          </tr>
      </ng-template>
    
    </p-table>
  </div>
</div>


